function easeInOutQuad(t, b, c, d) {
  t /= d / 2;
  if (t < 1) {
    return (c / 2) * t * t + b;
  }
  t -= 1;
  return (-c / 2) * (t * (t - 2) - 1) + b;
}

function createRAF() {
  return window.requestAnimationFrame || window.webkitRequestAnimationFrame || window.mozRequestAnimationFrame || function RAF(callback) { window.setTimeout(callback, 1000 / 60); };
}

const requestAnimFrame = createRAF();

export default function animation(start, to, duration, work) {
  const change = to - start;
  const increment = 20;
  let currentTime = 0;
  duration = (typeof (duration) === 'undefined') ? 500 : duration;
  const animateLoop = () => {
    currentTime += increment;
    const val = easeInOutQuad(currentTime, start, change, duration);
    work && work(val);
    if (currentTime < duration) {
      requestAnimFrame(animateLoop);
    }
  };
  animateLoop();
}
